import { ApolloClient, gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { ID } from "../../utils/id";
import getApolloClient from "../client";

interface Data {
  upload: {
    uri: string;
    stream: boolean;
    streamToken: string;
  };
}

interface Variables {
  id: ID;
  finished: boolean;
  stream?: boolean;
}

const MUTATION = gql`
  mutation upload($id: ID!, $finished: Boolean!, $stream: Boolean) {
    upload: uploadRecord(id: $id, finished: $finished, stream: $stream) {
      uri: uploadPath
      stream
      streamToken
    }
  }
`;

export const useRecordUploadMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation(MUTATION, options);
};

export const recordUploadMutate = (
  options: Omit<ApolloClient.MutateOptions<Data, Variables>, "mutation">,
): Promise<ApolloClient.MutateResult<Data>> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return getApolloClient().mutate<Data, Variables>({
    ...options,
    mutation: MUTATION,
  });
};
